module.exports = __webpack_public_path__ + "img/mini.020d3035.png";